import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { useEffect } from 'react';
import {
  NARRATIVE_COMMUNITY_AFTER_QUERY_PARAM,
  NARRATIVE_COMMUNITY_BEFORE_QUERY_PARAM,
} from '../utils';
import { useNarrativesCommunityInfinite } from './useNarrativesCommunityInfinite';
import { useQueryClient } from '@tanstack/react-query';

type Props = {
  hasFirstPage: boolean;
};

export const useNarrativeCommunityGoToStart = ({ hasFirstPage }: Props) => {
  const { getItem } = useQueryStringParam();
  const queryClient = useQueryClient();

  const initialAfter = getItem(NARRATIVE_COMMUNITY_AFTER_QUERY_PARAM);
  const initialBefore = getItem(NARRATIVE_COMMUNITY_BEFORE_QUERY_PARAM);

  useEffect(() => {
    // Only continue if we started paginating from the middle of the collection
    if (hasFirstPage) return;

    // When initialAfter and initialBefore are both nil, user wants to start from the beginning
    // we have to manually invalidate the query and reset the data to start from page 0
    if (initialAfter || initialBefore) return;

    // Removing paged data will force suspense to re-fetch the first page
    queryClient.removeQueries(useNarrativesCommunityInfinite.getAllOptions());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
};
